/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import * as ModelsFromStore  from '@apps-store/models';
import * as EnumsFromStore from '@apps-store/enums';
import { Dispatch } from 'redux';

import * as Utils from '@root-utils/index';

/**
 * @function RealTimesActionSuccess  - 
 * @return { object } payload
 * @returns { string }  type
 * @param { any } 
 */
export function RealTimesActionSuccess(data:any): ModelsFromStore.RealTimesActionSuccess {

    return {
        
        payload:{

            data,
            loading: false,
            

        },

        type :EnumsFromStore.RealTimesTypes.REALTIMES_SUCCESS

    }
}

/**
 * @function RealTimesActionFail  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param { any } 
 */
export function RealTimesActionFail(errors: any): ModelsFromStore.RealTimesActionFail {

    return {
        payload:{

            error: errors  ,
            loading: false,
            
        },

        type :EnumsFromStore.RealTimesTypes.REALTIMES_FAIL

    }
}
/**
 * @function RealTimesActionInProgress  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param {  } 
 */
export function RealTimesActionInProgress(): ModelsFromStore.RealTimesActionInProgress{

    return {
        payload:{

         
            loading: true,
            
        },

        type :EnumsFromStore.RealTimesTypes.REALTIMES_INPROGRESS

    }
}

// CONSTRUCTEUR

/**
 * @function RealTimesActionCreator 
 * @param {  } 
 * @return {Promise<any>}  Promise
 */
export function RealTimesActionCreator():(dispatch: Dispatch<any>, {}) => Promise<any>{
 
    return  async (dispatch: Dispatch<any>) => {

        dispatch(RealTimesActionInProgress());

        await Utils.realTimes()
            .then((res: any) => {
                if( res.ok ){ res.json().then( (data: any) => dispatch(RealTimesActionSuccess(data)))     
                }else{ dispatch(RealTimesActionFail("server error has occurred with HTTP status ("+res.status+ ")" ))}
            })
            .catch( (error : any) => dispatch(RealTimesActionFail(error)))  
    }
    
}  




// WEBPACK FOOTER //
// ./src/apps/store/action-creator/realtimes/index.ts